import { CircleCheck, Trash2 } from "lucide-react";

interface SingleSkill {
	added: boolean;
	skill: string;
}

interface SingleSkillItemProps {
	onRemoveSingleSkill: (groupedSkillIndex: number, singleSkillIndex: number) => void;
	singleSkill: SingleSkill;
	groupedSkillIndex: number;
	singleSkillIndex: number;
}

/**
 * One skill inside a category, sized to its own name. The chip used to be a fixed
 * 150px, which cut "Advocating for others" down to "Advocating f..." — a resume
 * line the reader could not read back.
 *
 * The bin removes the skill outright. It used to un-tick it instead, leaving the
 * chip in place behind a plus: the skill was gone from the resume but still on the
 * screen, so the card claimed more than it saved.
 */
function SingleSkillItem({
	onRemoveSingleSkill,
	singleSkill,
	groupedSkillIndex,
	singleSkillIndex,
}: SingleSkillItemProps) {
	return (
		<div className="group box-border flex min-h-[38px] max-w-full items-center gap-3 rounded-[5px] border border-black/18 border-dashed px-3 py-[9px]">
			<span className="min-w-0 wrap-break-word text-[#161616] text-sm">{singleSkill.skill}</span>
			{/* The tick reads as the resting state and the bin only as an answer to
			    pointing at the chip. Same button underneath either way, so a tap that
			    never raises a hover still removes the skill. */}
			<button
				type="button"
				className="shrink-0 cursor-pointer"
				aria-label={`Remove ${singleSkill.skill}`}
				onClick={(event) => {
					event.stopPropagation();
					onRemoveSingleSkill(groupedSkillIndex, singleSkillIndex);
				}}
			>
				<CircleCheck className="size-4 fill-success-default stroke-white group-hover:hidden" />
				<Trash2 className="hidden size-4 text-red-600 group-hover:block" />
			</button>
		</div>
	);
}

export default SingleSkillItem;
